import { useEffect, useState } from "react";

export default function useAudioTrack({ audioTrack }) {
  const [audioOn, setAudioOn] = useState(false);

  useEffect(() => {
    if (audioTrack) {
      setAudioOn(audioTrack.isTrackEnabled);

      const handleAudioDisabled = () => {
        setAudioOn(false);
      };

      const handleAudioEnabled = () => {
        setAudioOn(true);
      };

      audioTrack.on("disabled", handleAudioDisabled);
      audioTrack.on("enabled", handleAudioEnabled);
      audioTrack.track?.on("stopped", handleAudioDisabled);

      return () => {
        audioTrack.off("disabled", handleAudioDisabled);
        audioTrack.off("enabled", handleAudioEnabled);
        audioTrack.track?.off("stopped", handleAudioDisabled);
      };
    }
  }, [audioTrack]);

  return { audioOn };
}
